/* unplugin-vue-components disabled */import { render } from "./UserManage.vue?vue&type=template&id=b028543c&scoped=true"
import script from "./UserManage.vue?vue&type=script&lang=js"
export * from "./UserManage.vue?vue&type=script&lang=js"

import "./UserManage.vue?vue&type=style&index=0&id=b028543c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b028543c"]])

export default __exports__